import { Grid, Card, Skeleton, Stack } from '@/theme/index';

export function LoadingGarage({ panel }: { panel?: string }) {
  if (panel === 'full') {
    return (
      <Grid
        container
        spacing={2.5}
        sx={{ mt: 0.5 }}
        data-testid="my-garage-vehicle-loading-panel"
      >
        <Grid item xs={12} md={3}>
          <Skeleton variant="rounded" height={168} animation="pulse" />
          <Skeleton variant="text" sx={{ fontSize: '3rem' }} />
          <Skeleton variant="rounded" height={60} />
          <Skeleton variant="text" height={40} />
          <Skeleton variant="text" height={40} />
          <Skeleton variant="text" height={40} />
          <Skeleton variant="text" height={40} />
          <Skeleton variant="text" height={40} />
        </Grid>
        <OramLoading full />
      </Grid>
    );
  }

  return <OramLoading />;
}

const OramLoading = ({ full = false }) => {
  const skeletonArray = new Array(3).fill(0);

  return (
    <>
      <Grid item xs={12} md={full ? 4 : 6}>
        {skeletonArray.map((_, index) => {
          return (
            <Card variant="outlined" key={`left-${index}`}>
              <Stack justifyContent="space-between">
                <Skeleton
                  variant="circular"
                  width={40}
                  height={40}
                  sx={{ margin: '0 auto' }}
                />
                <Skeleton variant="text" sx={{ fontSize: '1.5rem' }} />
                <Skeleton variant="text" sx={{ fontSize: '1.5rem' }} />
                <Skeleton variant="text" sx={{ fontSize: '1.5rem' }} />
                <Skeleton variant="text" sx={{ fontSize: '1.5rem' }} />
              </Stack>
            </Card>
          );
        })}
      </Grid>
      <Grid item xs={12} md={full ? 4 : 6}>
        {skeletonArray.map((_, index) => {
          return (
            <Card variant="outlined" key={`right-${index}`}>
              <Stack justifyContent="space-between">
                <Skeleton
                  variant="circular"
                  width={40}
                  height={40}
                  sx={{ margin: '0 auto' }}
                />
                <Skeleton variant="text" sx={{ fontSize: '1.5rem' }} />
                <Skeleton variant="text" sx={{ fontSize: '1.5rem' }} />
                <Skeleton variant="text" sx={{ fontSize: '1.5rem' }} />
                <Skeleton variant="text" sx={{ fontSize: '1.5rem' }} />
              </Stack>
            </Card>
          );
        })}
      </Grid>
    </>
  );
};
